import { render, staticRenderFns } from "./b4Step.vue?vue&type=template&id=502bafcc&scoped=true&"
import script from "./b4Step.vue?vue&type=script&lang=js&"
export * from "./b4Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502bafcc",
  null
  
)

export default component.exports